<template lang="pug">
  .shop-product-tile.xs-f-small.max-at-tweak(tabindex="0" role="article")
    .product.text-center
      .prod-image(data-mr-ass="product-quicklook-img" :class="useSwatchStyles ? 'rcc' : 'default'")
        a.full-width.full-height(:href='productUrl' tabindex="0")
          img(:src='tileImage.url' :alt="tileImage.alt_text" :class="useSwatchStyles ? 'rcc-image' : 'default-image'" loading="lazy")

          p.ribbon.purple.upper.semi-bold.xs-f-xsmall.max-at-tweak(v-if="product.new") new

      .row.description-wrapper
        .stars-wrapper(v-if="averageReview.averageRating")
          Stars(:rating='averageReview.averageRating' :reviews-count="averageReview.numReviews" :show-total="true")

        a.text-color-1.upper.semi-bold.xs-f-xxsmall.sm-f-small.max-at-tweak(:href='productUrl' data-mr-ass="product-quicklook-name" tabindex="0") {{ product.name }}
        p.text-color-4.xs-f-xxsmall.sm-f-small.max-at-tweak.mb-5 {{ product.xsell_description }}

</template>
<script>
  import Stars from '@components/stars';

  export default {
    name: 'ShopProductTile',

    components: {
      Stars,
    },

    props: {
      averageReview: {
        type: Object,
        required: true,
      },
      product: {
        type: Object,
        required: true,
      },
      productUrl: {
        type: String,
        required: true,
      },
    },

    computed: {
      tileImage() {
        return this.product?.imagery?.toneSwatch || this.product?.imagery?.alternative || this.product?.imagery?.standard;
      },

      useSwatchStyles() {
        return this.product.product_type === 'color_kit' || this.product.product_type === 'colorwonder';
      }
    },
  };
</script>
<style lang="stylus">
  .shop-product-tile
    padding 0 1%

    .product
      .description-wrapper
        padding-top 0.75em

        .stars-wrapper
          padding-bottom 0.75em

    .prod-image
      overflow hidden
      position relative
      display inline-block
      vertical-align top
      text-align center
      width 96%

      &.rcc
        aspect-ratio 1/1
        border-radius 100%

        .ribbon
          top 5em
          left 5em
          min-width 16em

          @media mq-tablet-less
            top 4em
            left 4em

      .default-image
      .rcc-image
        width 100%

      .ribbon
        position absolute
        transform translate3D(-50%, -50%, 0) rotate(-45deg)
        top 4em
        left 4em
        background-color #d8e3f2
        padding 0.5em 3em
        min-width 15em
        text-align center
        background-color color-mr-purple
        color color-white

        @media mq-desktop-md-less
          top 3em
          left 3em

</style>